import React, { useState, useRef } from 'react';
import { Card, Form, Button, ProgressBar, Alert } from 'react-bootstrap';
import { apiService } from '../services/apiService';
import FileUploadModal from "./FileUploadModal.jsx";
import { useEnvironment } from '../contexts/EnvironmentContext';
import _ from "lodash";

const FileUpload = ({ user, handleCancel }) => {
    const {
        environment,        // 'development' or 'production'
        isDevelopment,      // boolean flag
        isProduction,       // boolean flag
        apiEndpoints,       // object with API endpoints
        changeEnvironment   // function to change environment
    } = useEnvironment();

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [xtraInfo, setXtraInfo] = useState('');
    const [uploadText, setUploadText] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [isUploadingText, setIsUploadingText] = useState(false);
    const [uploadError, setUploadError] = useState('');
    const [uploadSuccess, setUploadSuccess] = useState('');
    const [textUploadSuccess, setTextUploadSuccess] = useState('');
    const [response, setResponse] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const fileInputRef = useRef(null);
    const [inputType, setInputType] = useState('file');

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
        setUploadProgress(0);
        setUploadError('');
        setUploadSuccess('');
    };

    const handleFileUploadResponse = (response) => {
        setResponse(response);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setUploadProgress(0);
        setUploadError('');
        setUploadSuccess('');
        setSelectedFiles([]);
        setXtraInfo('');
        setUploadText('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setShowModal(false);
        if (inputType == 'text') {
            if ( textUploadSuccess === 'Message rejected'){
                setTextUploadSuccess(textUploadSuccess)
            }else{
                setTextUploadSuccess('Upload complete')
            }
            setTimeout(() => {
                setTextUploadSuccess('')
            }, 3000);
        }
    };

    const handleUploadText = async (event) => {
        event.preventDefault();
        if (_.isEmpty(uploadText)) {
            setUploadError('Please enter text to upload');
            setIsUploadingText(false);
            return;
        }

        try {
            setIsUploading(true);
            setUploadError('');

            const metadata = {
                description: uploadText,
                userid: user.id,
                approvestep: true,
                group_id: user.groupId
            }

            const response = await apiService.uploadFile(
                apiEndpoints.upload,
                '',
                metadata,
                (progress) => setUploadProgress(progress)
            );
            if (typeof response === 'object' && response !== null) {
                setResponse(response);
                handleFileUploadResponse(response);
            } else if (typeof response === 'string') {
                setUploadError(response);
            }
            setSelectedFiles([]);
            setUploadText('');

        } catch (error) {
            console.error('Upload error:', error);
            setUploadError(
                error.response?.data?.message ||
                error.message ||
                'Failed to upload file. Please try again.'
            );
        } finally {
            setIsUploading(false);
        }
    };

    const handleUpload = async (event) => {
        event.preventDefault();

        if (selectedFiles.length === 0) {
            setUploadError('Please select at least one file to upload');
            return;
        }
        if (selectedFiles.length > 2) {
            setUploadError('Please only upload a maximum of 2 files');
            return;
        }

        try {
            setIsUploading(true);
            setUploadError('');

            const responses = [];

            const metadata = {
                description: xtraInfo,
                userid: user.id,
                approvestep: true,
                group_id: user.groupId
            };
            const fileResponse = await apiService.uploadFile(
                apiEndpoints.upload,
                selectedFiles,
                metadata,
                (progress) => setUploadProgress(Math.floor((progress)))
            );

            if (typeof fileResponse === 'object' && fileResponse !== null) {
                setResponse(fileResponse);
                handleFileUploadResponse(fileResponse);
            } else if (typeof fileResponse === 'string') {
                setUploadError(fileResponse);
            }

            setSelectedFiles([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

        } catch (error) {
            console.error('Upload error:', error);
            setUploadError(
                error.response?.data?.message ||
                error.message ||
                'Failed to upload files. Please try again.'
            );
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <Card className="mb-4 shadow-sm">
            <Card.Header as="h5">
                <div className={"mb-3"}>Ian - Memory Input</div>
                <Form.Group className="mb-3 ">
                    <div className="mb-3">
                        <Form.Check
                            inline
                            type="radio"
                            name="inputType"
                            id="fileInput"
                            label="Upload files"
                            checked={inputType === 'file'}
                            onChange={() => setInputType('file')}
                            disabled={isUploading}
                        />
                        <Form.Check
                            inline
                            type="radio"
                            name="inputType"
                            id="textInput"
                            label="Enter text"
                            checked={inputType === 'text'}
                            onChange={() => setInputType('text')}
                            disabled={isUploading}
                        />
                    </div>
                </Form.Group>
            </Card.Header>
            {inputType === 'file' && (
                <Card.Body>
                    <Form onSubmit={handleUpload}>
                        <Form.Group controlId="fileUpload" className="mb-3">
                            <Form.Label>Select files to upload</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Extra Info about the files"
                                value={xtraInfo}
                                onChange={(e) => setXtraInfo(e.target.value)}
                                disabled={isUploading}
                                className="mb-3"
                            />
                            {/*<Form.Control*/}
                            {/*    type="file"*/}
                            {/*    accept=".jpg,.jpeg,.png"*/}
                            {/*    onChange={handleFileChange}*/}
                            {/*    disabled={isUploading}*/}
                            {/*    className="mb-3"*/}
                            {/*    ref={fileInputRef}*/}
                            {/*    multiple*/}
                            {/*/>*/}
                            <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                disabled={isUploading}
                                className="mb-3"
                                ref={fileInputRef}
                                multiple
                            />
                            {selectedFiles.length > 0 && (
                                <div className="mb-3">
                                    <p>Selected files ({selectedFiles.length}):</p>
                                    <ul>
                                        {selectedFiles.map((file, index) => (
                                            <li key={index}>{file.name} ({(file.size / 1024).toFixed(2)} KB)</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </Form.Group>

                        {uploadProgress > 0 && (
                            <div className="mb-3">
                                <ProgressBar
                                    now={uploadProgress}
                                    label={`${uploadProgress}%`}
                                    animated={isUploading}
                                />
                            </div>
                        )}

                        {uploadError && (
                            <Alert variant="danger" className="mb-3">
                                {uploadError}
                            </Alert>
                        )}

                        {uploadSuccess && (
                            <Alert variant="success" className="mb-3">
                                {uploadSuccess}
                            </Alert>
                        )}

                        <div className="d-flex justify-content-end align-items-center">
                            <Button
                                variant="primary"
                                type="submit"
                                disabled={selectedFiles.length === 0 || isUploading}
                            >
                                {isUploading ? 'Uploading...' : 'Upload Files'}
                            </Button>
                            <Button
                                className="me-2"
                                variant="warning"
                                type="button"
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
                )}

            {inputType === 'text' && (
                <Card.Body>
                    <Form onSubmit={handleUploadText}>
                        <Form.Group controlId="textUpload" className="mb-3">
                            <Form.Label>Enter your text</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Upload text information"
                                value={uploadText}
                                onChange={(e) => setUploadText(e.target.value)}
                                disabled={isUploadingText}
                                className="mb-3"
                            />
                        </Form.Group>
                        {textUploadSuccess && (
                            <Alert variant="success" className="mb-3">
                                {textUploadSuccess}
                            </Alert>
                        )}

                        <div className="d-flex justify-content-end align-items-center">

                            <Button
                                variant="primary"
                                type="submit"
                                disabled={isUploadingText}
                            >
                                {isUploading ? 'Uploading...' : 'Upload Text'}
                            </Button>
                            <Button
                                className="me-2"
                                variant="warning"
                                type="button"
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                    {uploadError && (
                        <Alert variant="danger" className="mb-3">
                            {uploadError}
                        </Alert>
                    )}
                </Card.Body>
            )}

            <FileUploadModal
                responseArr={response}
                show={showModal}
                onHide={handleModalClose}
                user={user}
                onApprovalComplete={(approvalResponse) => {
                    setTimeout(() => {
                        setTextUploadSuccess(_.get(approvalResponse,'responseMessage', ''))
                    }, 500);
                }}
            />
        </Card>
    );
};

export default FileUpload;